export interface CurbRegulationRecord {
    bl_side: string;
}

export const defaultCurbRegulationRecord = {
    bl_side: ""
};
